<template>
  <div>{{ data.text }}</div>
  <v-row>
    <v-col v-for="(checkbox, index) in data.props" :key="index" cols="12" md="4" class="flex-center">
      <v-checkbox :label="checkbox.text" :value="checkbox.value" v-model="value"></v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MultiCheckboxComponent',
  props: {
    data: Object,
    baseValue: [Object, String, Array, Boolean],
  },
  data: (props) => {
    return {
      value: props.baseValue,
    }
  },
  emits: ['formModEvent'],
  watch: {
    value() {
      this.sendDataToParent()
    },
  },
  methods: {
    sendDataToParent() {
      const dataToSend = [
        {
          key: this.data.name,
          value: this.value,
        },
      ]
      this.$emit('formModEvent', dataToSend)
    },
  },
})
</script>


<style lang="css" scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>